import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import Email from './Email'
import ShortText from './ShortText'
import LongText from './LongText'

const WorkApprovalForm = () => {
    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم تایید کار'} subHeader={'لطفا برای درخواست تایید کار، این فرم را تکمیل کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام کارمند'} />
                <Email header={'ایمیل'} />
                <ShortText header={'دپارتمان'} />
                <LongText header={'شرح کار'} />
                <LongText header={'نتایج مورد نظر'} />
                <LongText header={'صف بندی زمانی'} />
                <FullName header={'نام سرپرست'} />
                <Email header={'ایمیل سرپرست'} />
            </Grid>
        </Grid>
    )
}

export default WorkApprovalForm
